import LinkAsButton from './LinkAsButton'

export default LinkAsButton
